var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralTechnicalFaq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.843 101.407C140.843 101.407 157.294 82.9181 152.064 50.7471C146.835 18.5761 119.971 6.72324 102.154 12.9153C84.3382 19.1074 80.3197 29.8847 65.7685 36.0478C51.2173 42.2109 23.5672 37.9798 9.74049 58.6812C-4.08619 79.3825 13.5658 113.685 36.0382 135.195C58.5106 156.704 115.856 143.238 140.843 101.407Z",
    fill: "#FF725E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M140.843 101.407C140.843 101.407 157.294 82.9181 152.064 50.7471C146.835 18.5761 119.971 6.72324 102.154 12.9153C84.3382 19.1074 80.3197 29.8847 65.7685 36.0478C51.2173 42.2109 23.5672 37.9798 9.74049 58.6812C-4.08619 79.3825 13.5658 113.685 36.0382 135.195C58.5106 156.704 115.856 143.238 140.843 101.407Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75513 153.353H148.677",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.473 104.411L32.5864 153.288",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6783 143.261L29.405 140.858",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0974 141.58C30.0933 141.212 30.0104 140.849 29.8544 140.516C29.6983 140.182 29.4726 139.886 29.1925 139.648C28.6097 139.126 25.5378 137.835 25.2448 138.917C24.9293 140.095 28.072 142.407 30.0974 141.58Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0973 141.58L27.1736 139.758",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2483 148.725L29.975 146.323",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6672 147.044C30.6632 146.677 30.5803 146.314 30.4242 145.98C30.2682 145.647 30.0425 145.351 29.7624 145.112C29.1796 144.591 26.1077 143.3 25.8179 144.382C25.4991 145.56 28.658 147.869 30.6672 147.044Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6673 147.044L27.7435 145.222",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2874 129.926L28.014 127.527",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7063 128.245C28.7022 127.877 28.6193 127.515 28.4632 127.181C28.3072 126.848 28.0815 126.552 27.8014 126.313C27.2154 125.798 24.15 124.504 23.8537 125.579C23.5382 126.764 26.6809 129.073 28.7063 128.245Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7064 128.246L25.7826 126.427",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8573 135.391L28.584 132.992",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2762 133.711C29.2721 133.343 29.1893 132.98 29.0332 132.646C28.8771 132.313 28.6514 132.017 28.3714 131.779C27.7886 131.257 24.7167 129.966 24.4237 131.048C24.1081 132.226 27.2508 134.538 29.2762 133.711Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2763 133.71L26.3525 131.888",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.36 121.053L27.0867 118.65",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.779 119.372C27.7749 119.004 27.6921 118.641 27.536 118.308C27.3799 117.974 27.1542 117.678 26.8742 117.44C26.2914 116.918 23.2195 115.627 22.9297 116.709C22.6109 117.887 25.7601 120.199 27.779 119.372Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.779 119.371L24.8552 117.549",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4294 112.139L26.1561 109.737",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8484 110.446C26.8443 110.078 26.7614 109.715 26.6054 109.382C26.4493 109.049 26.2236 108.753 25.9435 108.514C25.3607 107.992 22.2888 106.701 21.999 107.783C21.6803 108.974 24.823 111.283 26.8484 110.446Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8483 110.455L23.9246 108.636",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2952 140.027L33.0243 137.21",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4962 138.057C32.4252 137.697 32.4321 137.325 32.5165 136.967C32.6009 136.61 32.7609 136.274 32.9857 135.984C33.4494 135.34 36.1864 133.456 36.6951 134.454C37.2457 135.539 34.6504 138.46 32.4962 138.057Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4962 138.057L35.1302 135.539",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7947 125.651L31.5238 122.833",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9957 123.677C30.9252 123.317 30.9323 122.946 31.0167 122.589C31.1011 122.232 31.2608 121.897 31.4852 121.607C31.9489 120.963 34.6859 119.076 35.1946 120.074C35.742 121.159 33.166 124.07 30.9957 123.677Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9957 123.677L33.6297 121.162",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1378 119.329L30.8637 116.512",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3389 117.359C30.2659 116.997 30.2716 116.624 30.3555 116.265C30.4394 115.905 30.5995 115.568 30.8251 115.276C31.2888 114.648 34.0258 112.748 34.5345 113.746C35.098 114.841 32.4898 117.752 30.3389 117.359Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3389 117.359L32.9696 114.844",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1686 110.068L29.8977 107.251",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3697 108.095C29.2986 107.734 29.3055 107.363 29.3899 107.005C29.4744 106.647 29.6343 106.312 29.8591 106.021C30.3228 105.393 33.0598 103.493 33.5685 104.492C34.132 105.577 31.5238 108.488 29.3697 108.095Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3696 108.095L32.0036 105.58",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4312 104.144C27.3602 103.784 27.3668 103.413 27.4507 103.056C27.5345 102.699 27.6937 102.364 27.9174 102.073C28.3811 101.429 31.1181 99.5424 31.6269 100.541C32.1807 101.626 29.5822 104.537 27.4312 104.144Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4312 104.144L30.0619 101.629",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5825 104.253C27.2169 104.286 26.8485 104.241 26.502 104.12C26.1554 103.999 25.8388 103.805 25.5732 103.552C24.9936 103.027 23.3933 100.103 24.4398 99.7036C25.5764 99.2657 28.1975 102.157 27.5825 104.253Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5826 104.254L25.3575 101.372",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6976 111.028L36.4666 153.288",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8142 149.91L35.0851 147.093",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M35.61 147.94C35.6815 147.579 35.6751 147.208 35.5913 146.85C35.5074 146.492 35.348 146.157 35.1238 145.866C34.6601 145.238 31.9038 143.341 31.4144 144.34C30.8605 145.425 33.4591 148.332 35.61 147.94Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6099 147.94L33.1273 145.554",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1989 136.576L36.4666 133.759",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9946 134.596C37.0657 134.235 37.0588 133.864 36.9744 133.506C36.8899 133.148 36.73 132.813 36.5052 132.522C36.0447 131.894 33.3045 129.998 32.7958 130.996C32.2451 132.091 34.8437 134.998 36.9946 134.596Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9946 134.605L34.5088 132.223",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6289 142.04L35.8998 139.223",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4279 140.069C36.4989 139.709 36.492 139.337 36.4076 138.98C36.3232 138.622 36.1632 138.286 35.9384 137.996C35.4747 137.368 32.7377 135.471 32.229 136.469C31.6784 137.555 34.2769 140.462 36.4279 140.069Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4279 140.069L33.942 137.687",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1198 127.701L37.3875 124.884",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9155 125.731C37.987 125.371 37.9806 124.999 37.8968 124.642C37.8129 124.284 37.6535 123.948 37.4293 123.657C36.9656 123.013 34.2254 121.13 33.7167 122.128C33.166 123.213 35.7646 126.121 37.9155 125.731Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9155 125.731L35.4297 123.345",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M40.044 118.785L38.3148 115.968",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8396 116.815C38.9111 116.454 38.9048 116.083 38.8209 115.725C38.737 115.367 38.5776 115.032 38.3534 114.741C37.8897 114.113 35.1334 112.216 34.644 113.215C34.0901 114.309 36.6887 117.207 38.8396 116.815Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8397 116.814L36.3571 114.432",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1041 146.668L39.3774 144.266",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6884 144.987C38.692 144.619 38.7744 144.256 38.9299 143.923C39.0854 143.59 39.3105 143.294 39.59 143.055C40.1728 142.533 43.2447 141.238 43.5345 142.32C43.8532 143.499 40.7105 145.811 38.6884 144.987Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6884 144.987L41.7796 143.067",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5981 132.29L40.8682 129.888",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1792 130.606C40.1833 130.238 40.2661 129.875 40.4222 129.542C40.5783 129.209 40.804 128.913 41.084 128.674C41.6668 128.153 44.7355 126.861 45.0285 127.94C45.3441 129.122 42.2046 131.434 40.1792 130.606Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1792 130.606L43.2736 128.687",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2518 125.97L41.5252 123.567",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8361 124.291C40.8397 123.924 40.9221 123.561 41.0776 123.228C41.2331 122.894 41.4582 122.598 41.7377 122.359C42.3205 121.838 45.3924 120.543 45.6822 121.625C46.0009 122.8 42.8582 125.112 40.8361 124.291Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8361 124.288L43.9273 122.369",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2146 116.706L42.4847 114.304",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7957 115.025C41.7997 114.657 41.8826 114.294 42.0387 113.961C42.1947 113.627 42.4204 113.331 42.7005 113.093C43.2833 112.571 46.352 111.277 46.645 112.358C46.9605 113.537 43.821 115.849 41.7957 115.025Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7957 115.025L44.8901 113.105",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7104 110.768C40.7145 110.4 40.7974 110.037 40.9535 109.704C41.1095 109.371 41.3352 109.075 41.6153 108.836C42.1981 108.314 45.2668 107.023 45.5598 108.105C45.8753 109.274 42.7358 111.586 40.7104 110.768Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7104 110.758L43.8049 108.839",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M40.836 110.897C40.4713 110.853 40.12 110.733 39.8056 110.543C39.4913 110.353 39.2212 110.098 39.0135 109.795C38.5563 109.151 37.5935 105.973 38.6915 105.796C39.9022 105.616 41.86 108.971 40.836 110.897Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8361 110.896L39.2518 107.618",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9854 91.4639L34.6698 153.362",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0336 143.087L33.0211 140.463",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 141.248C33.6663 140.882 33.6212 140.514 33.5007 140.168C33.3802 139.821 33.187 139.504 32.9342 139.238C32.4061 138.659 29.4888 137.055 29.0702 138.099C28.6581 139.238 31.5335 141.86 33.633 141.248Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 141.248L30.9153 139.133",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0336 131.668L33.0211 129.044",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 129.83C33.6663 129.465 33.6212 129.097 33.5007 128.75C33.3802 128.404 33.187 128.087 32.9342 127.821C32.4061 127.241 29.4888 125.638 29.0702 126.684C28.6581 127.834 31.5335 130.442 33.633 129.83Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 129.83L30.9153 127.715",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0336 118.264L33.0211 115.64",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 116.425C33.6663 116.06 33.6212 115.691 33.5007 115.345C33.3802 114.998 33.187 114.682 32.9342 114.416C32.4061 113.836 29.4888 112.233 29.0702 113.279C28.6581 114.416 31.5335 117.037 33.633 116.425Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 116.425L30.9153 114.31",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0336 109.338L33.0211 106.717",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 107.503C33.6668 107.137 33.6219 106.768 33.5014 106.421C33.3809 106.074 33.1875 105.756 32.9342 105.49C32.4061 104.914 29.4888 103.31 29.0702 104.353C28.6581 105.49 31.5335 108.114 33.633 107.503Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 107.502L30.9153 105.387",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0336 100.376L33.0211 97.752",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 98.5317C33.6668 98.1658 33.6219 97.797 33.5014 97.4498C33.3809 97.1027 33.1875 96.7854 32.9342 96.5192C32.4061 95.9396 29.4888 94.3361 29.0702 95.3826C28.6581 96.5289 31.5335 99.1532 33.633 98.5317Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M33.633 98.5413L30.9153 96.4258",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9885 146.571L36.9978 143.95",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 144.735C36.3526 144.369 36.398 144 36.5191 143.653C36.6402 143.306 36.8341 142.988 37.088 142.723C37.6128 142.146 40.5334 140.543 40.9359 141.586C41.3706 142.723 38.4854 145.347 36.386 144.735Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 144.735L39.2647 142.507",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9885 128.413L36.9978 125.789",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 126.578C36.3526 126.211 36.398 125.842 36.5191 125.495C36.6402 125.148 36.8341 124.831 37.088 124.565C37.6128 123.986 40.5334 122.382 40.9359 123.428C41.3706 124.565 38.4854 127.189 36.386 126.578Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 126.578L39.2647 124.347",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9885 119.449L36.9978 116.828",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 117.613C36.3526 117.247 36.398 116.878 36.5191 116.531C36.6402 116.184 36.8341 115.866 37.088 115.6C37.6128 115.024 40.5334 113.421 40.9359 114.464C41.3706 115.597 38.4854 118.225 36.386 117.613Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 117.613L39.2647 115.385",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9885 107.603L36.9978 104.981",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 105.767C36.3526 105.401 36.398 105.032 36.5191 104.685C36.6402 104.338 36.8341 104.021 37.088 103.755C37.6128 103.178 40.5334 101.575 40.9359 102.618C41.3706 103.755 38.4854 106.379 36.386 105.767Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 105.767L39.2647 103.539",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9885 98.2903L36.9978 95.666",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 96.4546C36.3526 96.0885 36.398 95.7194 36.5191 95.3723C36.6402 95.0252 36.8341 94.708 37.088 94.4421C37.6128 93.8625 40.5334 92.2589 40.9359 93.3054C41.3706 94.4421 38.4854 97.0664 36.386 96.4546Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M36.386 96.4548L39.2647 94.2266",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8661 92.3234C34.8327 91.9572 34.8781 91.5882 34.9992 91.2411C35.1203 90.894 35.3142 90.5768 35.5681 90.3109C36.0929 89.7313 39.0135 88.1309 39.4321 89.1742C39.8507 90.3109 36.9655 92.9352 34.8661 92.3234Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8662 92.3239L37.7449 90.0957",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0079 92.4459C34.6399 92.4418 34.277 92.3589 33.9438 92.2028C33.6105 92.0468 33.3146 91.8211 33.0759 91.541C32.5574 90.955 31.2694 87.8831 32.3514 87.5933C33.5299 87.2778 35.8354 90.4237 35.0079 92.4459Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0078 92.446L33.0919 89.3516",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M145.013 17.9678H93.116V90.0314H145.013V17.9678Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M142.971 20.8018H95.1575V87.1949H142.971V20.8018Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M129.869 38.998H108.263V68.9988H129.869V38.998Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7518 36.5121C85.7518 36.5121 82.4803 35.8681 79.6113 40.4115C76.7423 44.9549 76.9161 51.0375 77.0868 56.8335C77.2575 62.6295 76.9387 70.1321 76.7648 72.7725C76.5909 75.4129 73.7155 77.9534 73.7155 77.9534L114.777 78.9194C113.262 74.294 111.509 69.7499 109.525 65.3053C106.376 58.2825 103.649 47.0125 103.649 47.0125C103.649 47.0125 107.667 47.9302 107.323 45.6375C106.978 43.3449 104.682 40.7592 98.371 37.4909C92.0598 34.2226 87.8738 34.3321 85.7518 36.5121Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4503 153.272L72.0668 141.487L120.541 137.874L124.63 153.365L70.4503 153.272Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M117.868 124.467C116.668 122.035 115.604 119.539 114.68 116.99C115.534 114.932 118.399 109.69 118.399 109.69L120.099 106.628C120.099 106.628 119.777 105.685 119.858 103.179C119.913 101.891 119.88 100.6 119.758 99.3154C119.758 99.3154 121.545 84.7707 121.545 82.7292C121.545 80.6877 121.545 78.3081 121.036 77.6255C120.528 76.9429 117.037 74.5665 109.895 72.2674C102.753 69.9683 100.367 69.8878 99.8586 69.7172C99.3498 69.5465 90.3338 70.3129 90.3338 70.3129C90.3338 70.3129 76.2141 72.6925 75.5218 73.4588C74.8295 74.2252 77.4055 111.735 77.4055 111.735C77.4055 111.735 76.3461 114.475 76.095 116.53C74.8907 119.952 71.178 130.842 70.7498 136.036C70.241 142.244 70.3247 144.032 70.3247 144.032C70.3247 144.032 81.5496 149.132 87.0687 150.24C92.5878 151.347 97.4468 152.281 97.4468 152.281L99.3176 147.261L101.697 152.194C101.697 152.194 111.222 148.623 114.539 146.24C117.855 143.858 122.196 138.332 122.196 138.332C122.196 138.332 119.906 128.55 117.868 124.467Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M115.92 78.5684C115.92 78.5684 113.003 82.4324 112.378 84.3998",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M102.579 118.419C102.579 118.419 106.791 119.369 107.606 119.981C108.421 120.593 111.615 121.543 112.974 121.543C114.134 121.507 115.291 121.399 116.438 121.221L114.265 118.773C114.265 118.773 105.841 117.53 104.55 117.53C104.177 117.527 103.807 117.605 103.467 117.758C103.127 117.911 102.824 118.137 102.579 118.419Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7927 141.191C98.9666 142.946 99.0793 144.089 99.0793 144.209",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6385 120.273C96.6385 120.273 97.9266 132.67 98.635 139.622",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7992 99.917C98.8379 100.239 98.8797 100.532 98.9216 100.761C99.2629 102.545 98.8379 104.757 97.9878 105.352C97.1377 105.948 96.3778 108.572 96.6998 108.923",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4128 93.6152C98.4128 93.6152 98.4933 96.1494 98.6543 98.3132",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M92.517 67.0955C92.517 67.0955 91.3739 67.0246 91.0873 67.382C90.8007 67.7395 88.5918 70.4507 88.5113 71.0206C88.4308 71.5906 88.2955 80.3587 88.2955 81.0799C88.2955 81.8012 89.2937 84.0777 89.7928 82.793C90.2919 81.5082 90.6494 79.8692 91.1517 79.0127C91.654 78.1562 92.9323 79.94 92.9323 79.94L101.353 82.223C101.353 82.223 104.064 80.6517 104.573 79.647C105.081 78.6424 105.001 82.6449 105.645 82.7865C106.289 82.9282 106.859 81.8592 106.215 79.4345C105.571 77.0099 105.716 72.3698 104.788 69.5877C103.861 66.8057 103.217 66.5899 101.72 66.5191C100.222 66.4483 92.517 67.0955 92.517 67.0955Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3739 61.9081C91.3739 61.9081 91.9471 68.6701 91.9471 69.826C91.9471 70.982 91.6605 75.6768 92.8068 78.7744C93.9531 81.8721 97.2246 92.0279 97.9137 92.4304C98.6028 92.8329 99.3466 91.8573 100.609 88.5858C101.871 85.3142 104.74 80.5003 104.225 75.6703C103.71 70.8403 101.469 61.2705 101.469 61.2705L91.3739 61.9081Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3935 67.8391L91.9438 70.457L91.5703 66.3418L98.3935 67.8391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7534 81.4668C95.2024 85.6689 97.3663 92.1089 97.9137 92.4148C98.6027 92.8173 99.3466 91.8416 100.609 88.5701C101.275 86.8474 102.383 84.7061 103.211 82.3394C101.693 83.0233 100.024 83.3023 98.367 83.1494C96.7096 82.9965 95.1201 82.4168 93.7534 81.4668Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3188 55.3845C84.3188 55.3845 87.8866 64.2041 89.4708 65.476C91.0551 66.7479 96.455 68.7893 98.3387 68.638C100.222 68.4867 102.161 67.2598 102.673 66.0878C103.185 64.9157 105.323 61.9018 104.965 59.4642C104.608 57.0267 102.264 48.0461 102.264 48.0461C102.264 48.0461 97.4661 47.3345 94.1527 46.2075C90.8394 45.0805 88.9557 42.0215 88.9557 42.0215C88.9557 42.0215 88.3439 47.9334 86.9174 51.1437C85.4909 54.3541 84.3188 55.3845 84.3188 55.3845Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6901 52.9434C96.6901 52.9434 97.1795 55.6095 98.0908 56.1634C99.002 56.7172 99.3562 57.007 99.0052 57.6381C98.6543 58.2692 97.6013 58.6041 97.3212 58.6041",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8114 59.96C93.8114 59.96 95.9173 61.995 98.0232 61.644",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6787 53.2783C88.6787 53.2783 91.0003 51.9259 92.7681 52.6085",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8705 52.5153C96.8705 52.5153 96.3166 50.1421 99.0987 49.4756",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8726 55.3845C94.0787 55.9513 93.966 56.5148 93.6214 56.6403C93.2769 56.7659 92.8261 56.4085 92.62 55.8386C92.414 55.2686 92.5266 54.7116 92.8744 54.586C93.2222 54.4604 93.6665 54.8114 93.8726 55.3845Z",
    fill: "#263238"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M100.219 53.1918C100.425 53.7586 100.313 54.3221 99.9648 54.4476C99.617 54.5732 99.1727 54.2158 98.9666 53.6491C98.7605 53.0824 98.8732 52.5189 99.2178 52.3933C99.5623 52.2677 100.013 52.6251 100.219 53.1918Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3189 55.3848L83.0309 59.0201C83.0309 59.0201 84.4058 61.0294 85.2108 61.374C86.0158 61.7185 86.9303 60.9715 86.9303 60.9715L84.3189 55.3848Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9549 109.178C83.9549 109.178 101.05 111.986 104.885 111.986C108.72 111.986 112.114 111.815 112.539 111.644C112.964 111.474 118.335 110.965 118.747 111.731C119.159 112.498 119.005 113.943 119.005 113.943C119.203 114.778 119.288 115.636 119.259 116.494C119.214 117.195 118.98 117.87 118.58 118.448C118.678 118.656 118.714 118.889 118.684 119.117C118.654 119.346 118.558 119.561 118.409 119.736C117.897 120.416 117.813 121.024 116.876 121.182C115.939 121.34 113.817 120.841 113.476 120.757C113.135 120.673 109.564 120.245 108.627 119.736C107.976 119.362 107.293 119.048 106.585 118.799C105.885 118.641 105.175 118.527 104.46 118.458C104.46 118.458 87.7803 119.462 85.3299 119.298C82.8795 119.134 81.3339 119.131 81.3339 119.131L83.9549 109.178Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M108.073 105.706C108.073 105.706 109.454 111.744 110.649 113.525C111.843 115.305 114.442 117.949 116.799 117.031C119.156 116.113 119.787 116.342 120.19 111.972C120.592 107.603 120.476 104.386 119.845 103.179C119.357 102.315 118.778 101.505 118.119 100.764L108.073 105.706Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M109.683 74.2662C109.683 74.2662 106.463 71.4519 104.853 70.1864C103.135 68.7929 101.504 67.296 99.9681 65.7042C98.8185 64.4967 98.1262 63.8656 98.0135 64.9571C97.9008 66.0487 99.5656 68.6344 99.9101 69.0948C100.255 69.5553 102.209 71.7385 102.209 71.7385C102.209 71.7385 99.9101 73.3485 99.3337 73.8089C98.7573 74.2694 98.7606 74.7749 98.5867 76.108C98.4128 77.4411 99.0471 78.0046 100.023 78.2912C100.327 78.368 100.645 78.377 100.953 78.3175C101.261 78.2579 101.553 78.1313 101.807 77.9466C101.807 77.9466 104.106 79.4987 105.542 79.7273C106.978 79.9559 108.301 81.0507 108.301 81.0507C108.301 81.0507 107.841 102.303 107.783 102.834C107.725 103.365 110.829 103.236 113.817 102.258C116.805 101.279 117.614 100.132 117.614 100.132C117.614 100.132 113.75 81.8557 112.784 79.2668C111.818 76.6779 110.768 74.9005 109.683 74.2662Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M101.81 77.9468L100.316 76.7393C100.316 76.7393 100.258 77.2577 99.9713 77.4283",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M101.81 77.9468L100.316 76.7393C100.316 76.7393 100.258 77.2577 99.9713 77.4283",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M106.753 101.456C106.753 101.456 106.923 106.051 107.5 106.399C108.076 106.746 112.442 105.706 114.741 104.901C117.041 104.096 118.709 103.121 118.766 102.374C118.824 101.627 118.248 99.7977 117.846 98.8091C117.443 97.8206 116.88 98.0621 116.638 98.2939C116.397 98.5258 114.339 99.2599 111.235 100.075C108.131 100.889 106.695 100.593 106.753 101.456Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5164 91.8092C78.4102 90.6404 78.3232 89.5746 78.2556 88.6826L78.5164 91.8092Z",
    fill: "#FF725E"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5164 91.8092C78.4102 90.6404 78.3232 89.5746 78.2556 88.6826",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2134 72.6084C80.2134 72.6084 71.4517 73.1204 71.1104 74.5662C70.7691 76.0119 69.7516 87.4912 69.4103 98.8031C69.0689 110.115 69.6646 118.365 70.431 118.619C71.1974 118.873 79.9558 118.873 79.9558 118.873L81.0634 109.01L80.1264 107.565C80.1264 107.565 79.2377 96.3656 78.6517 90.2508",
    fill: "#FF725E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2134 72.6084C80.2134 72.6084 71.4517 73.1204 71.1104 74.5662C70.7691 76.0119 69.7516 87.4912 69.4103 98.8031C69.0689 110.115 69.6646 118.365 70.431 118.619C71.1974 118.873 79.9558 118.873 79.9558 118.873L81.0634 109.01L80.1264 107.565C80.1264 107.565 79.2377 96.3656 78.6517 90.2508",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2763 107.14C79.2763 107.14 77.5761 118.281 77.3217 118.79C77.0674 119.299 76.8967 120.236 77.9142 120.152C78.9317 120.068 81.7428 120.831 82.0841 120.065C82.4254 119.299 85.1463 110.965 84.8887 109.761C84.6311 108.557 83.443 108.151 83.0179 107.977C82.5929 107.803 79.7883 106.712 79.2763 107.14Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5443 102.245C75.1611 101.755 74.8488 101.369 74.6846 101.186",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2389 105.777L79.2764 107.139C79.2764 107.139 77.7018 105.04 76.3784 103.311",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3372 62.3975C81.3372 62.3975 78.8449 76.9068 78.7612 83.5786C78.6775 90.2505 81.3372 94.0919 85.008 95.3123C88.6788 96.5327 91.8666 94.3978 91.1035 93.332C90.3403 92.2662 87.2942 94.3978 86.2284 90.5886C85.1626 86.7793 88.9718 83.5786 89.1264 76.0986C89.2809 68.6185 89.1264 66.6511 89.1264 66.6511",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3372 62.3975C81.3372 62.3975 78.8449 76.9068 78.7612 83.5786C78.6775 90.2505 81.3372 94.0919 85.008 95.3123C88.6788 96.5327 91.8666 94.3978 91.1035 93.332C90.3403 92.2662 87.2942 94.3978 86.2284 90.5886C85.1626 86.7793 88.9718 83.5786 89.1264 76.0986C89.2809 68.6185 89.1264 66.6511 89.1264 66.6511",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1837 27.6916C75.1854 26.1875 74.8107 24.7068 74.0937 23.3846C73.3768 22.0623 72.3405 20.9404 71.0791 20.121C69.8178 19.3016 68.3715 18.8109 66.8719 18.6934C65.3724 18.5759 63.8673 18.8355 62.4937 19.4484C61.9042 18.2929 61.0723 17.2782 60.0547 16.4736C59.0372 15.669 57.858 15.0934 56.5977 14.7862C55.3374 14.479 54.0256 14.4474 52.752 14.6935C51.4783 14.9396 50.2728 15.4577 49.2177 16.2123C48.7772 15.0469 48.1 13.9854 47.2288 13.0949C46.3575 12.2043 45.3112 11.504 44.1558 11.038C43.0003 10.5721 41.7608 10.3507 40.5156 10.3878C39.2703 10.4249 38.0462 10.7196 36.9205 11.2535C35.5323 9.84931 33.7215 8.93966 31.7662 8.66429C29.8109 8.38892 27.8193 8.76304 26.0973 9.7292C24.3752 10.6954 23.018 12.2001 22.234 14.0124C21.45 15.8246 21.2826 17.8441 21.7575 19.7607C19.7226 20.5079 17.9167 21.7711 16.517 23.4264C15.1172 25.0817 14.1717 27.0723 13.773 29.2031C13.3743 31.3339 13.5361 33.5318 14.2427 35.5812C14.9492 37.6306 16.1762 39.4612 17.8033 40.8936C17.1916 42.7525 17.2012 44.7599 17.8308 46.6129C18.4604 48.4658 19.6758 50.0636 21.2934 51.1649C22.9111 52.2662 24.8431 52.8113 26.7979 52.7179C28.7526 52.6245 30.6239 51.8976 32.1291 50.647C33.0292 52.8435 34.5356 54.7386 36.4723 56.1112C38.409 57.4837 40.6962 58.2771 43.0669 58.3986C45.4375 58.5201 47.7938 57.9648 49.8607 56.7976C51.9277 55.6302 53.6199 53.8991 54.74 51.8062C56.7543 52.6322 58.983 52.7793 61.0884 52.2252C63.1939 51.6711 65.0614 50.4459 66.4081 48.7352C67.7548 47.0245 68.5073 44.9216 68.5517 42.7449C68.596 40.5682 67.9298 38.4363 66.654 36.6722C68.9538 36.548 71.1189 35.5484 72.705 33.8784C74.2911 32.2084 75.178 29.9948 75.1837 27.6916Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0047 55.9665C70.9592 55.0123 71.9586 53.0405 71.237 51.5623C70.5153 50.084 68.3459 49.6591 66.3914 50.6133C64.437 51.5674 63.4375 53.5392 64.1592 55.0174C64.8808 56.4957 67.0502 56.9206 69.0047 55.9665Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7309 60.4038C69.2719 61.5114 70.898 61.8302 72.3631 61.1154C73.8282 60.4005 74.5752 58.9226 74.0342 57.8149C73.4933 56.7072 71.8672 56.3884 70.4021 57.1033C68.937 57.8181 68.1899 59.2961 68.7309 60.4038Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2495 25.7599C76.2511 24.2558 75.8764 22.7751 75.1595 21.4528C74.4426 20.1306 73.4063 19.0086 72.1449 18.1893C70.8835 17.3699 69.4372 16.8792 67.9377 16.7617C66.4382 16.6442 64.9331 16.9037 63.5595 17.5167C62.9685 16.362 62.1354 15.3484 61.117 14.5451C60.0985 13.7418 58.9187 13.1677 57.6581 12.8621C56.3975 12.5564 55.0858 12.5263 53.8125 12.7739C52.5393 13.0215 51.3344 13.5409 50.2802 14.2967C49.8396 13.1329 49.1628 12.073 48.2925 11.1836C47.4222 10.2942 46.3772 9.59462 45.2233 9.12883C44.0694 8.66303 42.8316 8.44114 41.5877 8.47712C40.3439 8.5131 39.1209 8.80617 37.9959 9.33788C36.6086 7.92891 34.7967 7.01506 32.839 6.73704C30.8814 6.45902 28.8866 6.83227 27.1619 7.79929C25.4372 8.76632 24.0783 10.2735 23.2943 12.0887C22.5103 13.904 22.3448 15.9266 22.8233 17.8451C20.7868 18.5919 18.9794 19.8552 17.5784 21.5112C16.1774 23.1672 15.231 25.1589 14.8319 27.2909C14.4328 29.423 14.5948 31.6222 15.302 33.6728C16.0092 35.7233 17.2374 37.5549 18.8659 38.9876C18.253 40.847 18.2621 42.8554 18.8917 44.7092C19.5212 46.563 20.7371 48.1615 22.3555 49.2631C23.974 50.3648 25.907 50.9097 27.8626 50.8155C29.8181 50.7213 31.6898 49.9931 33.1949 48.741C34.0944 50.9372 35.5999 52.8322 37.5358 54.205C39.4716 55.5779 41.758 56.3719 44.128 56.4944C46.4981 56.617 48.8541 56.063 50.9212 54.8971C52.9883 53.7312 54.6813 52.0015 55.8025 49.9099C57.8169 50.7359 60.0455 50.883 62.151 50.3289C64.2564 49.7747 66.1239 48.5496 67.4706 46.8389C68.8173 45.1282 69.5699 43.0253 69.6142 40.8486C69.6586 38.6719 68.9924 36.54 67.7165 34.7759C70.023 34.6521 72.194 33.6479 73.7818 31.9703C75.3695 30.2927 76.2528 28.0697 76.2495 25.7599Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0658 54.0524C72.0203 53.0983 73.0198 51.1265 72.2981 49.6482C71.5765 48.17 69.4071 47.7451 67.4526 48.6992C65.4981 49.6533 64.4987 51.6251 65.2203 53.1034C65.9419 54.5816 68.1114 55.0065 70.0658 54.0524Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7967 58.4876C70.3377 59.5953 71.9638 59.914 73.4256 59.2024C74.8875 58.4908 75.6378 57.0096 75.0968 55.8987C74.5559 54.7878 72.933 54.4722 71.4679 55.1871C70.0028 55.9019 69.2557 57.3799 69.7967 58.4876Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5357 27.6212C53.5367 26.066 53.163 24.5334 52.4463 23.1531C51.7296 21.7729 50.691 20.5856 49.4183 19.6917C48.1456 18.7978 46.6763 18.2237 45.1348 18.0178C43.5932 17.812 42.0248 17.9805 40.5621 18.5091C39.0995 19.0377 37.7857 19.9109 36.732 21.0547C35.6782 22.1985 34.9155 23.5794 34.5083 25.0804C34.1012 26.5814 34.0616 28.1584 34.3929 29.6779C34.7242 31.1974 35.4167 32.6148 36.4118 33.8101C37.8373 35.5201 38.6179 37.676 38.6175 39.9023V41.2289H49.0857V39.9023C49.0835 37.6782 49.863 35.524 51.2882 33.8165C52.7404 32.0787 53.5359 29.8859 53.5357 27.6212Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M43.8434 34.4246C47.2347 34.4246 49.984 31.6754 49.984 28.2841C49.984 24.8928 47.2347 22.1436 43.8434 22.1436C40.4521 22.1436 37.7029 24.8928 37.7029 28.2841C37.7029 31.6754 40.4521 34.4246 43.8434 34.4246Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0857 41.2383H38.6174V43.8272H49.0857V41.2383Z",
    fill: "#7D7D7D",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6174 43.834H49.0857V44.903C49.0857 45.307 48.9252 45.6944 48.6396 45.98C48.3539 46.2656 47.9665 46.4261 47.5626 46.4261H40.1405C39.7366 46.4261 39.3492 46.2656 39.0635 45.98C38.7779 45.6944 38.6174 45.307 38.6174 44.903V43.834Z",
    fill: "#7D7D7D",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M39.928 46.4189H47.7526V46.9438C47.7526 47.4912 47.5351 48.0162 47.148 48.4033C46.761 48.7904 46.236 49.0078 45.6886 49.0078H42.0017C41.4542 49.0078 40.9293 48.7904 40.5422 48.4033C40.1551 48.0162 39.9376 47.4912 39.9376 46.9438V46.4189H39.928Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9073 27.6729H59.3445",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9431 27.6729H32.435",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6438 16.4217V11.9717",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6842 19.6325L54.7464 16.5703",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5413 38.7753L35.6486 35.668",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5165 19.5456L32.5413 16.5703",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7465 38.7749L51.7841 35.8125",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralTechnicalFaq);
export default __webpack_public_path__ + "static/media/GeneralTechnicalFAQ.8c5ff7edd90b1d3b2b7646745019251d.svg";
export { ForwardRef as ReactComponent };